import Modal from '../helpers/Modal';

export default class StudentModal {
    constructor(root) {
        this.root = root;
        this.modal = new Modal(this.root);
    }
}
